<script>
	import { Tabs, Tab } from "svelma";
	import { get, getJSON } from "../utils.js";

	import { fly, fade, slide } from "svelte/transition";
	import { flip } from "svelte/animate";

	import marked from "marked";

	import ProjectCard from "./ProjectCard.svelte";

	let allCardData = [];

	let activeTab = 0;
	let curCardData = allCardData;
	let starCount = 0;
	let totalStarCount = 0;

	let filters = ["", "Research", "Project"];
	let filter = (allCardData, type) => {
		let val = [];
		for (let i = 0; i < allCardData.length; i++) {
			if (type === "" || allCardData[i].type == type)
				val.push(allCardData[i]);
		}
		return val;
	};

	let onActiveTabChanged = (newTab) => {
		activeTab = newTab;
		curCardData = filter(allCardData, filters[newTab]);
	};

	// Get the projects
	getJSON("assets/projects/projects.json").then((data) => {
		allCardData = data["projects"];
		onActiveTabChanged(activeTab);

		for (let i = 0; i < allCardData.length; i++) {
			let id = allCardData[i].id;
			const descUrl = `assets/projects/${id}/description.md`;

			// Get Description Markdown
			get(descUrl).then((val) => {
				allCardData[i].description = marked(val);
				onActiveTabChanged(activeTab);
			});

			// Get Github Stars
			if (allCardData[i].links["Github"]) {
				getJSON(
					allCardData[i].links["Github"].replace(
						"github.com/",
						"api.github.com/repos/"
					)
				).then((data) => {
					allCardData[i].githubStars = data["stargazers_count"];
					starCount += 1;
				}).catch((error) => {
					allCardData[i].githubStars = undefined;
					starCount += 1;
				});
				onActiveTabChanged(activeTab);
				totalStarCount += 1;
			}
		}
	});
</script>

<Tabs on:activeTabChanged={(ev) => onActiveTabChanged(ev.detail)}>
	<Tab label="All" icon="ellipsis-h" iconPack="fas" />
	<Tab label="Research" icon="file-alt" iconPack="fas" />
	<Tab label="Projects" icon="file-code" iconPack="fas" />
</Tabs>

{#if totalStarCount > 0 && starCount >= totalStarCount}
{#each curCardData as card, idx (card.id)}
	<div
		animate:flip={{ duration: 600 }}
		in:fly={{ y: 200, duration: 600 }}
		style="margin-bottom:10px"
	>
		{#if idx === 0 || curCardData[idx - 1].year !== card.year}
			<h1>{card.year}</h1>
		{/if}
		
		<ProjectCard {...card} />
	</div>
{/each}
{/if}

<style>
	h1 {
		font-size: 2em;
		font-weight: 700;
		text-align: center;
	}
</style>
